import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import dataProvider from '../../admin/dataProvider';
import { useGetIdentity } from 'react-admin';
import { useState, useEffect } from 'react';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import StatCard from './StatCard';
import { useCurrentProject } from '../../contexts/AccountProjectContext';
async function getAccount(id: string) {
  const account = await dataProvider.getOne('accounts', { id });
  return account.data;
}

async function getPortfolio(id: string) {
  const portfolio = await dataProvider.getOne('portfolioByProject', { id });
  return portfolio.data;
}

function MainAccount() {
  const { data: user, isLoading, error, identity } = useGetIdentity();
  const [account, setAccount] = useState(null);
  const { projectId, hasUserCNHS } = useCurrentProject();
  const [portfolio, setPortfolio] = useState<number>(0);
  
  useEffect(() => {
    if (user?.accountId) {
      getAccount(user.accountId).then(result => {
        setAccount(result);
      });
    }
  }, [user]);

  useEffect(() => {
    if (hasUserCNHS) {
      getPortfolio(projectId).then(result => {
        const roundedPortfolio = Number(result?.data?.balance||0);
        setPortfolio(roundedPortfolio);
      });
    }
  }, [hasUserCNHS]);

  const { t }: { t: any } = useTranslation();

  if (!projectId) {
    return null;
  }

  return (
    <StatCard
      icon={<AccountBalanceWalletOutlinedIcon />}
      label={t('Coinhouse account balance')}
      footer={
        <Typography variant="body2" color="text.secondary">
          {t('Balance of the Coinhouse account linked to this entity.')}
        </Typography>
      }
    >
      <Typography variant="h2" color="text.primary" sx={{ fontVariantNumeric: 'tabular-nums' }}>
        {portfolio.toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' })}
      </Typography>
    </StatCard>
  );
}

export default MainAccount;
